<template>
  <div class="bank-select">
    <div class="bank-title-head">แจ้งข้อมูลการชำระเงิน</div>
    <div class="icon-container">
      <label class="label">หลักฐานการโอน</label>
      <image-upload-and-resize
        v-bind="chooseIconDialog"
        @confirm="handleConfirmChooseIconDialog"
      ></image-upload-and-resize>
    </div>
    <div class="mb-3">
      <div class="label">ผู้จัดหาบริการ</div>
      <el-select
        :value="sellerTradeSelected"
        clearable
        class="input-seller-trade"
        @change="handleChangeInput('sellerTradeSelect', $event)"
      >
        <el-option
          v-for="t in sellerTradePartyOptions"
          :key="t.value"
          :label="t.label"
          :value="t.value"
        ></el-option>
      </el-select>
    </div>
    <div
      v-if="
        bankInformationBySellerTrade && bankInformationBySellerTrade.length > 0
      "
    >
      <div class="mb-3">
        <p>ธนาคารที่โอน</p>
        <div
          v-for="(bank) in bankInformationBySellerTrade"
          :key="bank.id"
          class="grid-bank"
        >
          <div>
            <input
              :value="true"
              :checked="bank.isSelect"
              class="radio-option"
              type="radio"
              name="bank"
              @change="handleChangeInput('bank', bank.id)"
            />
          </div>
          <img v-if="bank.iconUrl" :src="bank.iconUrl" class="icon" />
          <div>
            <div>{{ bank.label }}</div>
            <div>เลขที่บัญชี: {{ bank.value }}</div>
          </div>
        </div>
      </div>
      <div v-if="channels && channels.length > 0" class="mb-3">
        <p>วิธีการรับเงิน</p>
        <div
          v-for="(channel, channelIndex) in channels"
          :key="channelIndex"
          class="grid-bank mb-2"
        >
          <div>
            <input
              :value="true"
              :checked="channel.isSelect"
              class="radio-option"
              type="radio"
              name="channel"
              @change="handleChangeInput('channel', channel.id)"
            />
          </div>
          <img v-if="channel.icon" :src="channel.icon" class="icon channel" />
          <div>
            <div class="channel-detail">{{ channel.label }}</div>
            <div class="channel-detail bank-title">{{ channel.detail }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <p>จำนวนเงินที่โอน</p>
      <el-input
        :value="value.slipAmount"
        @input="handleChangeInput('slipAmount', $event)"
      ></el-input>
    </div>
    <div class="mb-3">
      <p>ราคาสุทธิที่ได้</p>
      <el-input
        :value="netPrice"
        readonly
      ></el-input>
    </div>
    <div class="">
      <p>หมายเหตุ</p>
      <el-input
        :value="value.bankNote"
        type="textarea"
        rows="7"
        @input="handleChangeInput('bankNote', $event)"
      ></el-input>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import ImageUploadAndResize from "@/lib/components/ImageUploadAndResize";
import { formatDecimal } from "@/lib/formatter";
import { toCamelCaseObject } from "@/lib/util";

import { Input, Option, Select } from "element-ui";

export default {
  components: {
    "el-input": Input,
    ImageUploadAndResize,
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: { type: Object, required: true },
    iconUrl: { type: String, default: null },
    totalPrice: { type: Number, default: 0 }
  },
  data() {
    return {
      isShowModal: false,
      sellerTradeParties: [],
      bankInformationBySellerTrade: [],
      channels: [],
      bankInformation: [],
      netPrice: null
    };
  },
  computed: {
    chooseIconDialog() {
      return {
        isShow: this.isShowModal,
        isPreviewImage: true
      };
    },
    sellerTradePartyOptions() {
      const sellerTradePartyOptions = this.sellerTradeParties.map((seller) => ({
        value: seller.id,
        label: seller.name
      }));

      return sellerTradePartyOptions;
    },
    sellerTradeSelected() {
      return this.value.sellerTradePartyIdByPackage;
    }
  },
  watch: {
    totalPrice() {
      const chanelSelected = this.channels.find((channel) => channel.isSelect === true)

      if (chanelSelected) {
        this.handleChangeInput('channel', chanelSelected.id)
      }
    },
    sellerTradeSelected: {
      immediate: true,
      handler: function watchSellerTradeSelected() {
        this.refreshBankInformationBySellerTrade();
      }
    },
    bankInformation: {
      handler: function watchBankInformation() {
        this.refreshBankInformationBySellerTrade();
      }
    },
    "value.bankId": function watchBankId() {
      this.markSelectedBank();
    },
    bankInformationBySellerTrade(banks) {
      if (banks.length === 1 && this.value.bankId !== banks[0].value) {
        this.handleChangeInput('bank', banks[0].id);
      }
    }
  },
  async created() {
    await Promise.all([
      this.setupSellerTradeParties(),
      this.setupBankInformation()
    ]);
  },
  methods: {
    refreshBankInformationBySellerTrade() {
      const { sellerTradePartyIdByPackage } = this.value;
      this.bankInformationBySellerTrade = this.bankInformation
        .filter((bankInfo) => String(bankInfo.sellerTradeId) === String(sellerTradePartyIdByPackage))
        .map((bank) => ({ ...bank, isSelect: false }));
    },
    markSelectedBank() {
      this.bankInformationBySellerTrade = this.bankInformationBySellerTrade.map((bank) => ({
        ...bank,
        isSelect: bank.value === this.value.bankId
      }));
    },
    hideChooseIconDialog() {
      this.isShowModal = false;
    },
    handleConfirmChooseIconDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file });
      this.hideChooseIconDialog();
    },
    async handleChangeInput(key, value) {
      if (key === "slipAmount") this.$emit("input", { ...this.value, slipAmount: value });
      if (key === "bankNote") this.$emit("input", { ...this.value, bankNote: value });

      if (key === "bank") {
        const bankSelected = this.bankInformation.find((bank) => bank.id === value);

        if (!bankSelected) {
          this.$message.error('เกิดข้อผิดพลาดในการเลือก ธนาคาร');
          return
        }

        this.bankInformationBySellerTrade = this.bankInformationBySellerTrade.map((bank) => ({
          ...bank,
          isSelect: bank.id === value
        }));

        this.channels = bankSelected.channels.map((channel) => ({
            ...channel,
            isSelect: false
          }))

        this.netPrice = null;

        this.$emit("input", {
          ...this.value,
          bankName: bankSelected.label,
          bankId: bankSelected.value,
          channel: undefined,
          actualPrice: null
        });

        return;
      }

      if (key === "sellerTradeSelect") {
        const banksBySellerTradePartyId = this.bankInformation.filter(
          (bankInfo) => String(bankInfo.sellerTradeId) === String(value)
        );

        this.channels = [];
        this.bankInformationBySellerTrade = banksBySellerTradePartyId.map((bank) => ({
            ...bank,
            isSelect: bank.value === this.value.bankId
          }));

          this.$emit("input", {
            ...this.value,
            sellerTradePartyIdByPackage: value,
          });

        return;
      }

      if (key === "channel") {
        this.channels = this.channels.map((chan) => ({
            ...chan,
            isSelect: chan.id === value
          }))

        const channelSelects = this.channels.filter((chan) => chan.isSelect === true);

        if (channelSelects.length !== 1) {
          this.$message.error('เกิดข้อผิดพลาดในการเลือก วิธีการชำระเงิน');
          return
        }

        const channelSelect = channelSelects[0]

        if (channelSelect.feeType) {
          if (channelSelect.feeType === "BATH") {
            this.netPrice = formatDecimal(this.totalPrice - channelSelect.fee)
          } else if (channelSelect.feeType === "PERCENTAGE") {
            this.netPrice = formatDecimal(this.totalPrice * ((100 - channelSelect.fee) * 0.01))
          } else {
            this.netPrice = formatDecimal(this.totalPrice)
          }
        } else {
          this.netPrice = formatDecimal(this.totalPrice)
        }

        this.$emit("input", {
          ...this.value,
          channel: channelSelect.value,
          actualPrice: this.netPrice
        });
      }
    },
    async setupSellerTradeParties() {
      try {
        this.sellerTradeParties = await this.fetchSellerTradeParties();

        if (
          this.sellerTradeParties.length === 1
          && !this.value.sellerTradePartyIdByPackage
        ) {
          this.handleChangeInput('sellerTradeSelect', this.sellerTradeParties[0].id);
        }
      } catch (err) {
        if (err?.response?.status === 400) {
          this.$message.error(err.response.data.message);
        } else {
          this.$message.error(err.message);
        }
      }
    },
    async fetchSellerTradeParties() {
      const response = await baanRueJaiClient.admin.subscriptions.receipts.getSellerTradeParties();

      return response.data.result;
    },
    async setupBankInformation() {
      try {
        this.bankInformation = await this.fetchBankInformation()
      } catch (error) {
        this.$message.error("ไม่สามารถแสดงข้อมูล บัญชีธนาคารได้");
      }
    },
    async fetchBankInformation() {
      const response = await baanRueJaiClient.admin.subscriptions.subscribers.getBankInformationList()

      return toCamelCaseObject(response.data.result);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.grid-bank {
  display: grid;
  height: 70px;
  grid-template-columns: 40px 80px 200px;
}

.bank-select {
  padding-top: 20px;
  border-top: $border-head;
}

.bank-title {
  font-size: 14px;
  font-weight: normal;
  color: $orange;

  &-head {
    font-size: 16px;
    font-weight: bold;

    padding-bottom: 20px;
  }
}

.icon-container {
  max-width: 180px;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.thumbnail-button {
  display: block;
  width: 100%;
}

.radio-option {
  transform: scale(1.25);
  margin-right: 15px;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 10px;
}

.icon {
  display: block;
  margin-top: 0;

  border-radius: 8px;
  width: $logoSize;
  height: $logoSize;
  flex: 0 0 $logoSize;

  &.channel {
    border-top: 1px solid $orange;
    border-bottom: 1px solid $orange;
  }
}

.input-seller-trade {
  width: 400px;
}

.channel-detail {
  white-space: nowrap;
}
</style>
